import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { mdiChevronDown } from '@mdi/js';
import { Link, Icon, Margin } from '@upgrade/react-components';
import { SubMenuContainer, StyledMenuDropDown, MenuItemText } from './styles';

const ExternalLink = ({ children, to }) => (
  <Link href={to} target="_blank" rel="noreferrer noopener">
    {children}
  </Link>
);

const getMenuItemComponent = ({ to }) => {
  if (to?.startsWith('http')) {
    return ExternalLink;
  }

  if (to === '') {
    return StyledMenuDropDown;
  }

  return GatsbyLink;
};

const MenuItem = ({ label, to = '', icon, children, onClick, id, visibleSubMenuId, status, isNotFoundPage }) => {
  const LinkComp = getMenuItemComponent({ to });

  const matchId = visibleSubMenuId === id;

  const hasChildren = children !== undefined;
  const isMenuExpanded = hasChildren && matchId;

  const activeColor = isMenuExpanded ? 'actionablePrimary' : 'inherit';
  const displayMultilevelMenu = hasChildren && !isNotFoundPage;

  const isSubMenuVisible = displayMultilevelMenu && isMenuExpanded;

  const subMenuId = hasChildren ? `${id}-submenu` : undefined;

  const ariaProps = hasChildren
    ? {
        'aria-controls': subMenuId,
        'aria-expanded': isMenuExpanded
      }
    : {};

  return (
    <li id={id}>
      <Link
        {...{
          anchorComponent: LinkComp,
          to,
          href: to, // This is required for the Link component to use `<a>` instead of a `<button>`
          onClick,
          activeClassName: to ? 'active' : ''
        }}
        {...ariaProps}
      >
        <MenuItemText color={activeColor} bold>
          {icon && (
            <Margin className="hidden-md" right="sm">
              <Icon aria-hidden align="middle" icon={icon} size="1.5rem" color="actionablePrimary" />
            </Margin>
          )}
          {label}
          <Margin className="hidden-md" left="sm">
            {status}
          </Margin>
        </MenuItemText>

        {displayMultilevelMenu && (
          <Icon
            aria-hidden
            icon={mdiChevronDown}
            size="1.5rem"
            color={activeColor}
            style={{
              transform: `rotate(${matchId ? '180deg' : '0'})`
            }}
          />
        )}
      </Link>

      <SubMenuContainer id={subMenuId} visible={isSubMenuVisible}>
        {children}
      </SubMenuContainer>
    </li>
  );
};

export default MenuItem;
